module.exports = __webpack_public_path__ + "img/gao8.50ff6368.png";